<script>
import Multiselect from 'vue-multiselect';
import i18n from '@/Plugins/i18n';

export default {
    extends: Multiselect,

    components: {
        'vue-multiselect': Multiselect,
    },

    props: {
        placeholder: {
            default: i18n.t('form.select_an_option'),
        },
        showLabels: {
            default: false,
        },
        selectLabel: {
            default: i18n.t('form.select'),
        },
        selectedLabel: {
            default: i18n.t('form.selected'),
        },
        deselectLabel: {
            default: i18n.t('form.remove'),
        },
        options: {
            type: Array,
            required: true,
            default: () => [],
        },
        label: {
            type: String,
        },
        trackBy: {
            type: String,
        },
    },
};
</script>
